



import React, { useState } from 'react';
import { Atom } from 'react-loading-indicators';

function CarReport() {
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [zooId, setZooId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const zooList = [
        { id: 1, name: 'สวนสัตว์เปิดเขาเขียว' },
        { id: 2, name: 'สวนสัตว์เชียงใหม่' },
        { id: 3, name: 'สวนสัตว์นครราชสีมา' },
        { id: 4, name: 'สวนสัตว์อุบลราชธานี' },
        { id: 5, name: 'สวนสัตว์ขอนแก่น' },
        { id: 6, name: 'สวนสัตว์สงขลา' }
    ];

    const formatDateString = (date) => {
        if (!date) return '';
        const [year, month, day] = date.split('-');
        return `${year}-${parseInt(month)}-${parseInt(day)}`;
    };

    const fetchData = () => {
        setLoading(true);
        setError('');
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            zoo_id: zooId,
            startDate: formatDateString(startDate),
            endDate: formatDateString(endDate)
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://addpay.net/api/v1/zoo/report/car", requestOptions)
            .then(response => response.json())
            .then(result => {
                setData(result);
                setLoading(false);
            })
            .catch(error => {
                setError('ไม่สามารถดึงข้อมูลได้');
                setLoading(false);
            });
    };

    return (
        <div className="container mt-5">
            <h1 className="text-center">รายงานการใช้รถ</h1>
            <div className="row mb-4">
                <div className="col-md-4">
                    <label>สวนสัตว์</label>
                    <select
                        className="form-control"
                        value={zooId}
                        onChange={e => setZooId(e.target.value)}
                    >
                        <option value="">เลือกสวนสัตว์</option>
                        {zooList.map(zoo => (
                            <option key={zoo.id} value={zoo.id}>
                                {zoo.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-4">
                    <label>วันที่เริ่มต้น</label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-md-4">
                    <label>วันที่สิ้นสุด</label>
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                    />
                </div>
            </div>
            <div className="text-center mb-4">
                <button className="btn btn-primary" onClick={fetchData}>
                    ค้นหา
                </button>
            </div>
            {loading && <div className="text-center"><Atom color="#32cd32" size="medium" text="" textColor="" /></div>}
            {error && <div className="alert alert-danger">{error}</div>}
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {data > 0 ? (
                        <>
                            <tr>
                                <td colSpan="4" className="text-center">
                                    <div className="text-center mt-5">
                                        <div className="counter-container">
                                            <div className="counter" data-target="12000"></div>
                                            <div className="p-4 bg-light rounded shadow-lg">
                                                <h2 className="text-primary">จำนวนรถเข้าสวนสัตว์</h2>
                                                <p className="mb-1"><strong>วันที่:</strong> {startDate ? new Date(startDate).toLocaleDateString() : '-'}</p>
                                                <span className="display-4 text-success">{data}</span>
                                                <p>คัน</p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </>
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center">ไม่พบข้อมูล</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default CarReport;
